import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/short-term-storage-services.jpg'),
    alt: 'short term storage services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'short term storage services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Short-Term <span>Storage</span><span>Services Fast</span>',
  description:
    'Need a temporary storage solution for your belongings? Our short-term storage services offer flexible options, secure facilities, and easy access for any duration.',
  image: {
    url: '/images/v2/pages/landing-pages/short-term-storage-services/hero-image.jpg',
    alt: 'Short-Term Storage Services Fast'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up for Short-Term Storage' }
}

export const ourProcessSectionContent = {
  title: 'How Our Short-Term Storage Services Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/short-term-storage-services/how-our-short-term-storage-services-work.png',
    alt: 'How Our Short-Term Storage Services Work'
  },

  articles: [
    {
      id: 1,
      title: 'Flexible Storage Duration',
      description:
        'Choose storage periods that fit your needs, whether it’s for a few weeks, months, or just until your next move.',
      image: {
        src: '/images/v2/pages/landing-pages/short-term-storage-services/flexible-storage-duration.png',
        alt: 'Flexible Storage Duration'
      }
    },
    {
      id: 2,
      title: '24/7 Security',
      description:
        'Your items will be stored in our highly secure facilities, equipped with surveillance and access controls, ensuring your belongings are safe at all times.',
      image: {
        src: '/images/v2/pages/landing-pages/short-term-storage-services/security.png',
        alt: '24/7 Security'
      }
    },
    {
      id: 3,
      title: 'Easy Access',
      description: 'Access your stored items whenever you need them, with convenient and easy retrieval options.',
      image: {
        src: '/images/v2/pages/landing-pages/short-term-storage-services/easy-access.png',
        alt: 'Easy Access'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Temporary Storage Services Available',
  description:
    'Our temporary storage services are designed to meet your short-term needs with ease. Experience maximum convenience and flexibility, along with top-notch security for your belongings. Whether you need extra space during a move or renovations, we’ve got the perfect solution for you. Secure your storage today!',
  image: {
    src: '/images/v2/pages/landing-pages/short-term-storage-services/temporary-storage-services-available.jpg',
    alt: 'Temporary Storage Services Available'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Winter Storage',

  cards: [
    {
      id: 1,
      title: 'Affordable and Flexible Plans',
      description:
        'Our short-term storage solutions come with competitive pricing and no long-term commitment, giving you the flexibility you need.',
      image: {
        src: '/images/v2/pages/common/secure-and-reliable.png',
        alt: 'Affordable and Flexible Plans'
      }
    },
    {
      id: 2,
      title: 'Security and Peace of Mind',
      description:
        'Rest assured knowing your items are stored in a highly secure facility with advanced monitoring and safety measures.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Security and Peace of Mind'
      }
    },
    {
      id: 3,
      title: 'Convenient Access and Location',
      description:
        'Easily access your items whenever necessary, with our strategically located storage facilities close to you.',
      image: {
        src: '/images/v2/pages/common/convenient-and-accessible.png',
        alt: 'Convenient Access and Location'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Our Short-Term Storage Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Homeowners in Transition',
          description:
            "Whether you're moving between homes, renovating, or decluttering, our short-term storage options provide the perfect solution."
        },
        {
          id: 2,
          title: 'Students',
          description:
            'Store your items during breaks or between school years with flexible, short-term storage that’s easy to arrange.'
        },
        {
          id: 3,
          title: 'Business Owners',
          description:
            'Need temporary storage for inventory, office furniture, or equipment? Our short-term storage can accommodate your business needs.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/short-term-storage-services/who-should-use-our-short-term-storage-services.jpg',
        alt: 'Who Should Use Our Short-Term Storage Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Short-Term Storage Services',

  cards: [
    {
      id: 1,
      title: 'Business Storage',
      description:
        'Keep your office supplies, documents, or inventory safe in a secure, short-term storage unit, available on your schedule.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Vehicle Storage',
      description:
        'Need temporary space for a car, bike, or RV? Our short-term vehicle storage options are ideal for your needs.',
      image: {
        src: '/images/v2/pages/common/vehicle-storage.png',
        alt: 'Vehicle Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Household Storage',
      description:
        'Store furniture, clothing, or personal belongings for as long as you need, with easy access when you’re ready to retrieve them.',
      image: {
        src: '/images/v2/pages/common/moving-box-solution.png',
        alt: 'Household Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Specialty Storage',
      description:
        'Store seasonal items such as holiday decorations, outdoor gear, or winter clothes without taking up space in your home.',
      image: {
        src: '/images/v2/pages/common/residential-storage-services.png',
        alt: 'Specialty Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Short-Term Storage?',

  image: {
    url: '/images/v2/pages/landing-pages/short-term-storage-services/why-choose-shipandstorage-for-short-term-storage.jpg',
    alt: 'Why Choose ShipAndStorage for Short-Term Storage?'
  },

  articles: [
    {
      id: 1,
      title: 'Security You Can Trust',
      description: 'Our storage facilities are equipped with top-tier security systems to protect your belongings.'
    },
    {
      id: 2,
      title: 'Custom Storage Options',
      description:
        'Whether you have a few boxes or large furniture items, we have storage solutions that fit your needs.'
    },
    {
      id: 3,
      title: 'Affordable and Transparent Pricing',
      description: 'We offer clear, competitive pricing with no hidden fees, so you can budget with confidence.'
    },
    {
      id: 4,
      title: 'Quick and Simple Setup',
      description: 'Set up your short-term storage with ease, and enjoy a hassle-free process from start to finish.'
    },
    {
      id: 5,
      title: 'Convenient and Flexible Access',
      description: 'Access your belongings at your convenience, with easy retrieval options available at all times.'
    },
    {
      id: 6,
      title: 'Customer-Focused Service',
      description:
        'Our team is dedicated to providing exceptional service, ensuring your storage experience is smooth and worry-free.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Fast Short-Term Storage Services Available',
  description:
    'Short-term storage services for temporary needs. Affordable, secure solutions for storing your belongings for short-term use.',
  image: {
    src: '/images/v2/pages/landing-pages/short-term-storage-services/fast-short-term-storage-services-available.png',
    alt: 'Fast Short-Term Storage Services Available'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started Now' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Shipping Partners',
  description:
    "We collaborate with top global carriers to ensure safe and timely delivery of your items, whether you're shipping to or from our storage facilities.",

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx provides reliable, fast, and secure shipping options to ensure your belongings are handled with care.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL offers international shipping services, ensuring safe and timely delivery of your items, regardless of destination.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS provides reliable, cost-effective shipping for your short-term storage needs, whether local or international.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
